import React from 'react';

import HighlightsSection from '../../HighlightsSection/HighlightsSection';
import SearchBar from '../../SearchBar/SearchBar';
import SortFilterContainer from '../SortFilterContainer/SortFilterContainer';
import Table from '../Table/Table';

import styles from './Layout.scss';

const Layout: React.FC = () => (
  <div className={styles.container}>
    <HighlightsSection />
    <SortFilterContainer />
    <SearchBar hideUpcomingToggle />
    <Table />
  </div>
);

export default Layout;
